import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBigHash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 79,
	height: 74,
	viewBox: "0 0 79 74",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3747 73.4349L18.3018 53.9557H0.770508L2.37468 47.4245H19.9059L25.1768 26.4557H5.35384L6.95801 19.9245H26.7809L31.5934 0.445312H38.1247L33.3122 19.9245H54.2809L59.0934 0.445312H65.6247L60.8122 19.9245H78.3434L76.6247 26.4557H59.0934L53.9372 47.4245H73.7601L72.0413 53.9557H52.2184L47.4059 73.4349H40.8747L45.8018 53.9557H24.7184L19.9059 73.4349H13.3747ZM26.4372 47.4245H47.4059L52.6768 26.4557H31.5934L26.4372 47.4245Z",
		fill: "#6B719D"
	})
});
export default SvgBigHash;
